import React, { useState, useEffect, useCallback, useRef } from "react";
import { legends } from "./legends";
import InfoTimeCard from "../Info/InfoTimeCard";
import MonthPicker from "../FormFields/Custom/MonthPicker";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
// import timesheetData from "../../dummydata/timesheetData";
import { mapTableRows, toTitle } from "../../utils";
import CustomHourPicker from "../FormFields/Custom/CustomHourPicker";
import Button from "../Buttons/Button";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import weekOfYear from "dayjs/plugin/weekOfYear";
import isoWeek from "dayjs/plugin/isoWeek";
import duration from "dayjs/plugin/duration";
import {
  addTimesheetStart,
  clearTimesheetData,
  getTimesheetOneStart,
  updateTimesheetStart,
} from "../../redux/slices/timesheets/timsheetSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLoginUser } from "../../hooks/useLoginUser";
import { showToast } from "../Toast/Toast";
import NewTable from "../Table/NewTable";
import PageHeader from "../Common/PageHeader";
import PageTitle from "../Common/PageTitle";
import Divider from "../Common/Divider";
import InfoTimeCardAdv from "../Info/InfoTimeCardAdv";
import { exactUTCDate } from "../../utils/dateFormator";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(weekOfYear);
dayjs.extend(isoWeek);
dayjs.extend(duration);
dayjs.extend(isBetween);

const TimeSheet = ({
  hideKeys = ["status"],
  weekend = 2,
  cellEdit = true,
  placementId,
  currentPlacementData,
  isEditable = true,
  setIsEditable,
  timesheetId, //optional
  startDate, //optional
  endDate, //optional
  showButtons = true,
  exposeState,
  submitTimesheet = false,
  hasInvoice = false,
}) => {
  // console.log("rendering TimesheetDetails with id", timesheetId);

  const dispatch = useDispatch();
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  const timesheetDataFromDb =
    useSelector((state) => state.timesheet.currentTimesheet.details) || [];

  const [timesheetData, setTimesheetData] = useState([]);
  //working 1
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [dates, setDates] = useState({
    startDate: startDate ? dayjs(startDate).local() : dayjs(),
    endDate: endDate ? dayjs(endDate).local() : dayjs(),
    // startDate: startDate ? dayjs(startDate).utc() : dayjs(),
    // endDate: endDate ? dayjs(endDate).utc() : dayjs(),
  });

  //testing
  useEffect(() => {
    if (submitTimesheet) {
      setSelectedDate(startDate ? dayjs(startDate) : dayjs());
    } else {
      setSelectedDate(startDate ? dayjs(startDate).utc() : dayjs());
    }
  }, [startDate, endDate]);

  const [filteredData, setFilteredData] = useState([]);
  // tetsing
  // useEffect(() => {
  //   if (exposeState) {
  //     exposeState(filteredData);
  //   }
  // }, [filteredData]);
  // }, [filteredData, exposeState]);
  const lastExposedRef = useRef(null);
  //working
  useEffect(() => {
    if (
      exposeState &&
      JSON.stringify(lastExposedRef.current) !== JSON.stringify(filteredData)
    ) {
      exposeState(filteredData);
      lastExposedRef.current = filteredData;
    }
  }, [filteredData, exposeState]);
  const [timeSheetKeys, setTimeSheetKeys] = useState([
    "payClassification",
    "standardTime",
    "totalBillableHours",
    "totalHours",
  ]);

  const [editingCell, setEditingCell] = useState(null);
  const [tempValue, setTempValue] = useState(null);
  const dateChanger = (date) =>
    setSelectedDate((prev) => {
      return dayjs(date);
    });
  //initial fetch
  useEffect(() => {
    if (!timesheetId) {
      //only with placement data
      if (placementId) {
        dispatch(
          getTimesheetOneStart({
            ref: "UpdatedBy Invoice Employee Client",
            filters: {
              //if something goes wrong
              // "period.year": {
              //   type: "NONE",
              //   value: selectedDate.format("YYYY"),
              // },
              // "period.month": {
              //   type: "NONE",
              //   value: selectedDate.format("MM"),
              // },
              "period.from": {
                type: "GTE",
                value: selectedDate.startOf("month").toISOString(),
              },
              "period.to": {
                type: "LTE",
                value: selectedDate.endOf("month").toISOString(),
              },
              employeeId: {
                type: "NONE",
                value: currentPlacementData?.employeeId?.uiid,
              },
              placementId: {
                type: "NONE",
                value: placementId,
              },
              clientId: {
                type: "NONE",
                value: currentPlacementData?.entityId?.uiid,
              },
            },
            // onSuccess: () => {
            //   showToast("Timesheet found", "success", 2000);
            // },
          }),
        );
      }
    } else {
      dispatch(
        getTimesheetOneStart({
          ref: "UpdatedBy Invoice Employee Client",
          incl: ["firstName lastName employmentType", "invoiceNum"],
          filters: {
            uiid: {
              type: "NONE",
              value: timesheetId,
            },
            placementId: {
              type: "NONE",
              value: placementId,
            },
          },
        }),
      );
    }

    return () => {
      dispatch(clearTimesheetData());
    };
    // }, [selectedDate, currentPlacementData]);
    //working
    // }, [selectedDate]);
    //testing
  }, []);

  //mapper main
  useEffect(() => {
    let mapped = [];
    if (startDate && endDate) {
      const start = dayjs(startDate);
      const end = dayjs(endDate);
      const temp = [];

      for (let d = start; d.isSameOrBefore(end); d = d.add(1, "day")) {
        if (d.day() !== 0 && d.day() !== 6) {
          mapped.push({
            payClassification: String(d),
            standardTime: dayjs.duration(8, "hours").format("HH:mm"),
            totalHours: dayjs.duration(8, "hours").format("HH:mm"),
            totalBillableHours: dayjs.duration(8, "hours").format("HH:mm"),
          });
        }
      }
      // setFilteredData(temp);
    } else {
      mapped =
        timesheetDataFromDb?.dailyEntries?.map((item) => ({
          payClassification: String(item.date),
          // payClassification: Str),
          status: "Rejected",
          standardTime: dayjs.duration(item.st, "hours").format("HH:mm"),
          // as per new changes the th and tbh is same as st as per update on 29-5-2025
          totalHours: dayjs.duration(item.th, "hours").format("HH:mm"),
          totalBillableHours: dayjs.duration(item.tbh, "hours").format("HH:mm"),
        })) || [];
    }

    setFilteredData(mapped);
    // return () => {
    //   setFilteredData([]);
    // };
  }, [timesheetDataFromDb, startDate, endDate]);
  // }, [timesheetDataFromDb]);
  //shows notification for dev
  useEffect(() => {
    let timeoutId;

    const showNotification = () => {
      const from = timesheetDataFromDb?.uiid;
      const to = timesheetDataFromDb?.period?.from;

      // if (from && to) {
      //   showToast("Timesheet found", "success", 3000);
      // } else {
      //   if (!submitTimesheet) {
      //     showToast("Timesheet not found", "error", 4000);
      //   }
      // }
    };

    const throttleShowToast = () => {
      if (timeoutId) return;

      timeoutId = setTimeout(() => {
        showNotification();
        timeoutId = undefined;
      }, 1500);
    };

    throttleShowToast();

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [timesheetDataFromDb]);

  const timeToDecimal = (timeStr) => {
    if (!timeStr) return 0;
    const [hours, minutes] = timeStr.split(":").map(Number);
    return Number((hours + minutes / 60).toFixed(2));
  };

  const handleSave = (statusType) => {
    const userApprovalFlowSettings =
      currentPlacementData?.employeeId?.approvalFlow || {};
    const isUserDelegator =
      userApprovalFlowSettings?.delegator?.userId === loginUserUiid;
    if (!isUserDelegator) {
      showToast("Permission Denied: You do not have delegation rights for this employee", "error", 5000);
      return;
    }
    // }
    if (!filteredData?.length) {
      showToast("The timesheet is empty. Please enter hours before saving", "error", 3000);
      return;
    }

    try {
      let createdPayload;
      if (timesheetDataFromDb?.uiid) {
        //for update payload
        createdPayload = [
          {
            type: "SET",
            value: {
              // ...(hasInvoice && {invoiceId :timesheetDataFromDb?.invoiceId?.map(ts=>ts.uiid)}),
              _skipFlatten: ["dailyEntries"],
              status: statusType,
              dailyEntries: filteredData.map((item) => ({
                // date: dayjs(item.payClassification, "YYYYMMDD").toISOString(),
                ...timesheetDataFromDb?.dailyEntries?.find(
                  (entry) =>
                    entry.date ===
                    Number(
                      dayjs
                        .utc(item.payClassification, "YYYYMMDD")
                        .format("YYYYMMDD"),
                    ),
                ),
                date: dayjs
                  .utc(item.payClassification, "YYYYMMDD")
                  .format("YYYYMMDD"),
                st: timeToDecimal(item.standardTime),
                th: timeToDecimal(item.standardTime),
                tbh: timeToDecimal(item.standardTime),
                // as per new changes the th and tbh is same as st as per update on 29-5-2025
                // th: timeToDecimal(item.totalHours),
                // tbh: timeToDecimal(item.totalBillableHours),
              })),
              amounts: {
                total:
                  currentPlacementData?.payments[
                    currentPlacementData?.payments.length - 1
                  ]?.payRate?.payType === 1
                    ? filteredData?.reduce(
                        (acc, item) => acc + timeToDecimal(item.standardTime),
                        0,
                      ) *
                      (currentPlacementData?.payments[
                        currentPlacementData?.payments.length - 1
                      ]?.payRate?.payRatePerHour || 0)
                    : currentPlacementData?.payments[
                        currentPlacementData?.payments.length - 1
                      ]?.payRate?.payRatePerHour || 0,
              },
            },
          },
          {
            type: "PUSH",
            value: {
              ...(statusType && {
                auditHistory: [
                  {
                    timestamp: new Date(),
                    status: statusType,
                    // as per new changes the th and tbh is same as st as per update on 29-5-2025

                    st: filteredData.reduce(
                      (acc, item) => acc + timeToDecimal(item.standardTime),
                      0,
                    ),
                    // as per new changes the th and tbh is same as st as per update on 29-5-2025

                    tbh: filteredData.reduce(
                      (acc, item) =>
                        // acc + timeToDecimal(item.totalBillableHours),
                        acc + timeToDecimal(item.standardTime),
                      0,
                    ),
                    // as per new changes the th and tbh is same as st as per update on 29-5-2025

                    th: filteredData.reduce(
                      // (acc, item) => acc + timeToDecimal(item.totalHours),
                      (acc, item) => acc + timeToDecimal(item.standardTime),
                      0,
                    ),
                    // updatedBy: loginUserData?.employeeId, // plug in your user identifier
                    updatedBy: loginUserUiid, // plug in your user identifier
                   
                  },
                ],
              }),
            },
          },
        ];
      } else {
        //for create payload
        createdPayload = {
          employeeId: currentPlacementData?.employeeId?.uiid,
          placementId: currentPlacementData?.uiid,
          clientId: currentPlacementData?.entityId?.uiid,
          addedBy: loginUserData?.employeeId,
          status: statusType,
          period: {
            month: selectedDate.format("MM"),
            year: selectedDate.format("YYYY"),
            from: selectedDate.startOf("month").toISOString(),
            to: selectedDate.endOf("month").toISOString(),
          },
          dailyEntries: filteredData.map((item) => ({
            // date: dayjs(item.payClassification, "YYYYMMDD").toISOString(),
            date: dayjs
              .utc(item.payClassification, "YYYYMMDD")
              .format("YYYYMMDD"),
            st: timeToDecimal(item.standardTime),
            th: timeToDecimal(item.standardTime),
            tbh: timeToDecimal(item.standardTime),
            // as per new changes the th and tbh is same as st as per update on 29-5-2025
            // th: timeToDecimal(item.totalHours),
            // tbh: timeToDecimal(item.totalBillableHours),
          })),
          onSuccess: (resData) => {
            dispatch(
              getTimesheetOneStart({
                ref: "UpdatedBy Invoice Employee Client",

                filters: {
                  uiid: {
                    type: "NONE",
                    value: resData?.data?.timesheetId,
                  },
                },
              }),
            );
          },
        };
      }
      if (timesheetDataFromDb?.uiid) {
        //updating existing timesheet
        dispatch(
          updateTimesheetStart({
            coll: "Timesheet",
            uiid: timesheetDataFromDb.uiid,
            ...(hasInvoice && { preActions: ["DuplicateInvoice"] }),
            payload: createdPayload,
            onSuccess: async (resData) => {
              dispatch(
                getTimesheetOneStart({
                  ref: "UpdatedBy Invoice Employee Client",
                  filters: {
                    uiid: {
                      type: "NONE",
                      value: resData?.data?.doc?.uiid,
                    },
                  },
                }),
              );
            },
          }),
        );
      } else {
        //create new timesheet if no timesheet found
        dispatch(addTimesheetStart(createdPayload));
      }
    } catch (error) {
      showToast("Unable to add timesheet. Please verify the data and try again", "error", 3000);
    }
  };
  const handleCellClick = (day, key) => {
    if (!isEditable) return;
    // if (day.date.day() === 0 || day.date.day() === 6) {
    //   console.warn("Not Editable Reason ::::::: Weekend (Saturday/Sunday)");
    //   return;
    // }
    if (!cellEdit) {
      console.warn("Not Editable Reason ::::::: Cell editing disabled");
      return;
    }
    if (
      key === "payClassification" ||
      key === "totalHours" ||
      key === "totalBillableHours"
    ) {
      console.warn(`Not Editable Reason ::::::: Field ${key} is not editable`);
      return;
    }
    if (!day.isCurrentMonth) {
      console.warn(
        "Not Editable Reason ::::::: Day is outside the current month",
      );
      return;
    }
    if (day.date.isAfter(dayjs(), "day")) {
      console.warn("Not Editable Reason ::::::: Future date");
      return;
    }
    if (
      timesheetDataFromDb?.period?.from &&
      day.date.isBefore(dayjs(timesheetDataFromDb?.period?.from).local(), "day")
    ) {
      console.warn("Not Editable Reason ::::::: Before timesheet period start");
      return;
    }
    if (
      timesheetDataFromDb?.period?.to &&
      day.date.isAfter(dayjs(timesheetDataFromDb?.period?.to).local(), "day")
    ) {
      console.warn("Not Editable Reason ::::::: After timesheet period end");
      return;
    }
    // if (startDate && dayjs.utc(startDate).isAfter(dayjs.utc(day.date), "day")) {
    //   console.log("Before placement startDate", dayjs.utc(startDate).isAfter(dayjs.utc(day.date), "day"));
    //   console.log("data",startDate,day.date);
    //   return;
    // }
    // if (endDate && dayjs.utc(endDate).isBefore(dayjs.utc(day.date), "day")) {
    //   console.log("After placement endDate");
    //   return;
    // }

    setTempValue(day.data?.[key] || "00:00");
    setEditingCell({ date: day.date.format("YYYY-MM-DD"), key });
  };
  //major change in this function according to new update on 29-05-2025
  //so the standard time should also reflect in the total hours and total billable hours
  // const handleSaveEdit = (e, value) => {
  //   e.stopPropagation();
  //   const updatedData = [...filteredData];
  //   const dayIndex = updatedData.findIndex(
  //     (item) =>
  //       dayjs(item.payClassification).format("YYYY-MM-DD") === editingCell.date
  //   );

  //   if (dayIndex === -1) {
  //     updatedData.push({
  //       payClassification: editingCell.date,
  //       [editingCell.key]: value,
  //     });
  //   } else {
  //     updatedData[dayIndex] = {
  //       ...updatedData[dayIndex],
  //       [editingCell.key]: value,
  //     };
  //   }

  //   setFilteredData(updatedData);
  //   setEditingCell(null);
  //   setTempValue(null);
  // };
  //mew change according to 29-5-25
  //it will sync the standard time with total hours and total billable hours
  const handleSaveEdit = (e, value) => {
    e.stopPropagation();
    const updatedData = [...filteredData];
    const dayIndex = updatedData.findIndex(
      (item) =>
        dayjs(item.payClassification).format("YYYY-MM-DD") === editingCell.date,
    );

    if (dayIndex === -1) {
      updatedData.push({
        payClassification: editingCell.date,
        // [editingCell.key]: value,
        standardTime: value,
        totalHours: value,
        totalBillableHours: value,
      });
    } else {
      updatedData[dayIndex] = {
        ...updatedData[dayIndex],
        // [editingCell.key]: value,
        standardTime: value,
        totalHours: value,
        totalBillableHours: value,
      };
    }

    setFilteredData(updatedData);
    // setEditingCell(null);
    // setTempValue(null);

    // const nextNonWeekendDate = dayjs(editingCell.date)
    //   .add(1, "day")
    //   .day() === 0 || dayjs(editingCell.date).add(1, "day").day() === 6
    //   ? dayjs(editingCell.date).add(2, "day")
    //   : dayjs(editingCell.date).add(1, "day");
    // setEditingCell({ date: nextNonWeekendDate.format("YYYY-MM-DD"), key: "standardTime" });
    let nextDate = dayjs(editingCell.date).add(1, "day");
    while (nextDate.day() === 0 || nextDate.day() === 6) {
      nextDate = nextDate.add(1, "day");
    }
    if (!nextDate.isAfter(dayjs(timesheetDataFromDb?.period?.to), "day")) {
      setEditingCell({
        date: nextDate.format("YYYY-MM-DD"),
        key: "standardTime",
      });
      setTempValue("08:00");
    }
  };

  const handleCancelEdit = (e) => {
    e.stopPropagation();
    setEditingCell(null);
    setTempValue(null);
  };

  const handleCellEdit = (day, key, value) => {
    const newValue = parseFloat(value) || 0;
    const updatedData = [...filteredData];
    const dayIndex = updatedData.findIndex(
      (item) =>
        dayjs(item.payClassification).format("YYYY-MM-DD") ===
        day.date.format("YYYY-MM-DD"),
    );

    if (dayIndex === -1) {
      updatedData.push({
        payClassification: day.date.format("YYYY-MM-DD"),
        [key]: newValue,
      });
    } else {
      updatedData[dayIndex] = {
        ...updatedData[dayIndex],
        [key]: newValue,
      };
    }

    setFilteredData(updatedData);
    setEditingCell(null);
  };

  const handleDateChange = (date) => {
    const newDate = dayjs(date);
    if (!newDate.isSame(selectedDate, "month")) {
      dateChanger(newDate);
    }
  };

  const generateCalendarData = () => {
    // const startOfMonth = selectedDate.utc().startOf("month");
    // const endOfMonth = selectedDate.utc().endOf("month");
    // console.log("selectedDate", selectedDate);
    let UTCDate = selectedDate;
    // console.log(`UTCDate`, UTCDate.format("YYYY-MM-DD"));
    // const startOfMonth = selectedDate.startOf("month");
    // const endOfMonth = selectedDate.endOf("month");
    // const startDate = startOfMonth.startOf("isoWeek");
    // const endDate = endOfMonth.endOf("isoWeek");
    const startOfMonth = UTCDate.startOf("month");
    const endOfMonth = UTCDate.endOf("month");
    const startDate = startOfMonth.startOf("isoWeek");
    const endDate = endOfMonth.endOf("isoWeek");
    // console.log({ startOfMonth, endOfMonth, startDate, endDate, selectedDate });

    const weeks = [];
    let currentDate = startDate;

    while (
      currentDate.isBefore(endDate) ||
      currentDate.isSame(endDate, "day")
    ) {
      const week = [];
      for (let i = 0; i < 7; i++) {
        const dayData = filteredData.find(
          (item) =>
            dayjs(item.payClassification).format("YYYY-MM-DD") ===
            currentDate.format("YYYY-MM-DD"),
        );

        week.push({
          date: currentDate,
          isCurrentMonth: currentDate.month() === selectedDate.month(),
          data: dayData || null,
        });

        currentDate = currentDate.add(1, "day");
      }
      weeks.push(week);
    }

    return weeks;
  };

  // Add this helper function
  const isWeekendDay = (dayIndex) => {
    return weekend > 0 && dayIndex >= 7 - weekend;
  };

  const columns = [
    {
      key: "dateTime",
      label: "Date & Time",
    },
    {
      key: "record",
      label: "Record",
    },
    {
      key: "des",
      label: "Description",
    },
    {
      key: "updatedBy",
      label: "Updated By",
    },
  ];
  // const data = timeshe
  // etDataFromDb?.auditHistory?.map((history) => ({
  //   dateTime: dayjs(history.timestamp).local().format("DD MMM YYYY HH:mm"),
  //   record: history.status,
  //   des: `${history.st} hours`,
  //   updatedBy: history.updatedBy,
  // })) || [
  //   {
  //     dateTime: "dateTime",
  //     record: "record",
  //     des: "des",
  //     updatedBy: "updatedBy",
  //   },
  // ];
  const TimesheetStatus = {
    1: "Draft",
    2: "Submitted",
    3: "Approved",
    4: "Rejected",
    5: "Job Inactive",
    6: "Invoiced",
  };

  const data = timesheetDataFromDb?.auditHistory?.map((history) => ({
    dateTime: dayjs(history.timestamp).local().format("DD-MMM-YYYY  HH:mm:ss"),
    record: `${[
      currentPlacementData?.employeeId?.firstName,
      currentPlacementData?.employeeId?.lastName,
    ]
      .filter(Boolean)
      .join(" ")} - ${timesheetDataFromDb?.period?.from ? exactUTCDate(timesheetDataFromDb?.period?.from) : "-"} to ${timesheetDataFromDb?.period?.to ? exactUTCDate(timesheetDataFromDb?.period?.to) : "-"}`,
    des: `${TimesheetStatus[history.status]} with ${history.st} Hours by ${
      history?.updatedBy?.firstName && history?.updatedBy?.lastName
          ? [history.updatedBy.firstName, history.updatedBy.lastName]
              .filter(Boolean)
              .join(" ")
          : ""
      }`,
    updatedBy: [history?.updatedBy?.firstName, history?.updatedBy?.lastName]
      .filter(Boolean)
      .join(" "),
  })) || [
    {
      dateTime: "dateTime",
      record: "record",
      des: "des",
      updatedBy: "updatedBy",
    },
  ];

  const mappedRows = mapTableRows(data, columns);
  return (
    <>
      <div id="table-wrapper">
        <div className="px-0">
          {/* to debug */}
          {/* <h4>Is Editable: {isEditable ? "true" : "false"}</h4>
      <h6>Timesheet ID: {timesheetDataFromDb?.uiid || "-"}</h6>
      <h6>Placement Id: {currentPlacementData?.uiid || "-"}</h6> */}
          <div className="bg-primary-500 text-white px-2 py-1 rounded-md hidden">
            {`selected date  :::: ${selectedDate.$d}`}
            <br />
            {/* {`date to fetch  :::: ${new Date(
          selectedDate.utc().startOf("month").startOf("day").$d
        ).toISOString()}`} */}
            <br />
            {`date to fetch  :::: ${selectedDate
              .startOf("month")
              .startOf("day")
              .toISOString()}`}
            <br />
            <table>
              <tbody>
                <tr>
                  <td>Start date from db in utc:</td>
                  <td>{currentPlacementData?.jobInfo?.startDate}</td>
                </tr>
                <tr>
                  <td>End date from db in utc:</td>
                  <td>{currentPlacementData?.jobInfo?.endDate}</td>
                  {/* <td>
              {selectedDate.startOf("month").startOf("day").toISOString()}
            </td> */}
                </tr>
              </tbody>
            </table>
          </div>

          <div className="time-sheet-header flex flex-col-reverse lg:flex-row items-end  gap-x-10 gap-y-3">
            <div className="grid grid-cols-3 gap-4">
              {/* <InfoTimeCard title="Total Time" value="184" color="info" /> */}
              <InfoTimeCardAdv
                title="Total Time"
                align="center"
                value={
                  // parseFloat(
                  //   (timesheetDataFromDb?.dailyEntries || [])
                  //     //correct one
                  //     ?.reduce((total, entry) => total + entry.th, 0)
                  //     // ?.reduce((total, entry) => total + entry.tbh, 0)
                  //     ?.toFixed(2)
                  // ) ||
                  (filteredData || [])
                    //correct one
                    ?.reduce(
                      (total, entry) => total + timeToDecimal(entry.totalHours),
                      0,
                    )
                    // ?.reduce((total, entry) => total + entry.tbh, 0)
                    ?.toFixed(2) || 0
                }
                color="info"
              />
              {/* <InfoTimeCard title="Billable Hours" value="183" color="success" /> */}
              <InfoTimeCardAdv
                title="Billable Hours"
                align="center"
                value={
                  // parseFloat(
                  //   (timesheetDataFromDb?.dailyEntries || [])
                  //     .reduce((total, entry) => total + entry.tbh, 0)
                  //     ?.toFixed(2)
                  // ) ||
                  (filteredData || [])
                    //correct one
                    ?.reduce(
                      (total, entry) =>
                        total + timeToDecimal(entry.totalBillableHours),
                      0,
                    )
                    // ?.reduce((total, entry) => total + entry.tbh, 0)
                    ?.toFixed(2) || 0
                }
                color="success"
              />
              {/* <InfoTimeCard title="Standard Time" value="183" color="primary" /> */}
              <InfoTimeCardAdv
                title="Standard Time"
                align="center"
                value={
                  // parseFloat(
                  //   (timesheetDataFromDb?.dailyEntries || [])
                  //     ?.reduce((total, entry) => total + entry.st, 0)
                  //     ?.toFixed(2)
                  // ) ||
                  (filteredData || [])
                    //correct one
                    ?.reduce(
                      (total, entry) =>
                        total + timeToDecimal(entry.standardTime),
                      0,
                    )
                    // ?.reduce((total, entry) => total + entry.tbh, 0)
                    ?.toFixed(2) || 0
                }
                color="primary"
              />
            </div>
            <div className="flex-1 flex flex-col gap-2">
              <div className="flex justify-end">
                <MonthPicker
                  //cprrect one
                  selected={selectedDate}
                  //testing
                  // selected={startDate ? dates.startDate : selectedDate}
                  // selected={startDate}
                  onChange={(date) => handleDateChange(date)}
                  placeholder="Select month"
                  size="md"
                  disabled={false}
                  // minDate={dayjs("2022-05-01")}
                  // maxDate={dayjs()}

                  // working
                  // minDate={dayjs
                  //   .utc(currentPlacementData?.jobInfo?.startDate)
                  //   .startOf("month")}
                  // maxDate={dayjs
                  //   .utc(currentPlacementData?.jobInfo?.endDate)
                  //   .endOf("month")}

                  // testing and current
                  minDate={
                    !submitTimesheet
                      ? dayjs(currentPlacementData?.jobInfo?.startDate)
                          // .endOf("month")
                          .startOf("month")
                          .local()
                      : // : dayjs(startDate).endOf("month").local()
                        dayjs(startDate).startOf("month").local()
                  }
                  maxDate={
                    !submitTimesheet
                      ? dayjs(currentPlacementData?.jobInfo?.endDate)
                          .endOf("month")
                          .local()
                      : dayjs(endDate).endOf("month").local()
                  }
                />
                {showButtons && (
                  <>
                    {timesheetDataFromDb?.status !== 6 && (
                      <>
                        <Button
                          title="Save"
                          className="ml-4"
                          onClick={() => handleSave(1)}
                          disabled={!isEditable}
                        />
                        <Button
                          title="Submit"
                          className="ml-4"
                          onClick={() => handleSave(2)}
                          disabled={!isEditable}
                        />
                      </>
                    )}
                  </>
                )}
                {/* working buttons */}
                {/* <Button
              title="Save"
              className="ml-4"
              onClick={() => handleSave(1)}
              disabled={!isEditable}
            />{" "}
            <Button
              title="Submit"
              className="ml-4"
              onClick={() => handleSave(2)}
              disabled={!isEditable}
            />{" "} */}
                {/* <div>
              {`start date from db----${
                currentPlacementData?.jobInfo?.startDate
              }-- ${dayjs
                .utc(currentPlacementData?.jobInfo?.startDate)
                .tz("America/New_York")}`}
              <br />
              {`end date from db----${
                currentPlacementData?.jobInfo?.endDate
              }-- ${dayjs
                .utc(currentPlacementData?.jobInfo?.endDate)
                .tz("America/New_York")}`}
            </div> */}
                {/* only dayjs */}
                {/* <div>
              {`start date dayjs takes--${dayjs
                .utc(currentPlacementData?.jobInfo?.startDate)
                .tz("America/New_York")}`}
             <br />
              {`end date dayjs takes--- ${dayjs
                .utc(currentPlacementData?.jobInfo?.endDate)
                .tz("America/New_York")}`}
            </div> */}
              </div>
              <div className="flex-1 flex flex-wrap gap-x-4 gap-y-2 items-center justify-end">
                {legends.map((item, index) => (
                  <div key={index} className="flex items-center gap-1">
                    <div
                      className={`w-2.5 h-2.5 rounded-full ${item.color}`}
                    ></div>
                    <span className="text-xs text-nowrap">{item.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
          {/* {cellEdit ? 1 : 0}----{timesheetData.length} */}
          <div className="mt-6">
            <div className="grid grid-cols-[repeat(8,1fr)_1.2fr] gap-2">
              {/* Header */}
              <div className="" />
              {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map(
                (day, index) => (
                  <div
                    key={day}
                    className={`flex items-center justify-center h-10 body-two ${
                      isWeekendDay(index)
                        ? "bg-primary text-white"
                        : "bg-primary text-white"
                    }`}
                  >
                    {day}
                  </div>
                ),
              )}
              <div className="flex items-center justify-center h-10 bg-primary text-white body-two">
                Total
              </div>

              {/* Calendar Data */}
              {generateCalendarData().map((week, weekIndex) => {
                const weekTotals = timeSheetKeys.reduce((totals, key) => {
                  if (key !== "payClassification") {
                    const total = week.reduce((sum, day) => {
                      // Only include current month days in the total
                      if (day.isCurrentMonth) {
                        const value = day.data
                          ? // ? parseFloat(day.data[key]) || 0
                            timeToDecimal(day.data[key]) || 0
                          : 0;
                        return sum + value;
                      }
                      return sum;
                    }, 0);
                    totals[key] = total;
                  }
                  return totals;
                }, {});

                return (
                  <React.Fragment key={weekIndex}>
                    <div className="flex flex-col gap-1">
                      {timeSheetKeys.map((key, index) => (
                        <div
                          key={index}
                          className="flex items-center justify-end h-10 mr-2 info-text text-right"
                        >
                          {toTitle(key)}
                        </div>
                      ))}
                    </div>
                    {week.map((day, dayIndex) => (
                      <div
                        key={dayIndex}
                        className={` flex flex-col gap-1 border-[1px] border-primary border-b-0 ${
                          !day.isCurrentMonth
                            ? "bg-gray-100 opacity-50 "
                            : isWeekendDay(dayIndex)
                              ? "bg-gray-100"
                              : ""
                        }`}
                      >
                        {timeSheetKeys.map((key, index) => (
                          <div
                            key={index}
                            className={`flex items-center justify-center h-10 border-b-[1px] border-primary ${
                              key === "payClassification"
                                ? // ? "bg-neutrals body-two"
                                  "bg-primary-50 body-two"
                                : isWeekendDay(dayIndex)
                                  ? "body-two text-gray-800"
                                  : !day.isCurrentMonth
                                    ? "body-two text-gray-400 "
                                    : "body-two"
                            }`}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleCellClick(day, key);
                            }}
                          >
                            {key === "payClassification" ? (
                              day.date.format("DD/MMM")
                            ) : editingCell?.date ===
                                day.date.format("YYYY-MM-DD") &&
                              editingCell?.key === key ? (
                              <div
                                className="flex gap-0.5 justify-between items-center w-full h-full"
                                onClick={(e) => e.stopPropagation()}
                              >
                                <div className="flex-1 justify-center">
                                  <CustomHourPicker
                                    value={tempValue}
                                    onChange={(value) => setTempValue(value)}
                                    cancelEdit={handleCancelEdit}
                                    saveEdit={handleSaveEdit}
                                  />
                                </div>
                              </div>
                            ) : (
                              //as per new update on 29-5-2025
                              //should this saved value in db as 8 hours
                              // day.data?.[key] || "08:00"
                              //old one correct one
                              day.data?.[key] || "--"
                            )}
                          </div>
                        ))}
                      </div>
                    ))}
                    <div className="flex flex-col gap-1 border-[1px] border-primary border-b-0">
                      <div className="flex items-center justify-center h-10 body-two bg-primary-50 text-gray-800 border-b-[1px] border-primary">
                        Week {weekIndex + 1}
                      </div>
                      {timeSheetKeys.map(
                        (key, index) =>
                          key !== "payClassification" && (
                            <div
                              key={index}
                              className="flex items-center justify-center h-10 body-one border-b-[1px] border-primary"
                            >
                              {/* {weekTotals[key]?.toFixed(2) || "--"} */}
                              {weekTotals[key] || "--"}
                            </div>
                          ),
                      )}
                    </div>
                  </React.Fragment>
                );
              })}
            </div>
          </div>
        </div>
        {!submitTimesheet && (
          <div>
            <PageHeader
              Section={
                <div className="flex gap-3 mt-2">
                  <PageTitle title={"Activities"} tag="h5" size={"sm"} />
                </div>
              }
            />
            <Divider className="my-2" />
            <NewTable
              rows={mappedRows}
              columns={columns}
              toolbarRight={[
                { filterButton: false },
                { DropdownMenu: false },
                { customSearch: false },
              ]}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default TimeSheet;
